import RestService from '@/modules/backend/RestService';
import { Rate } from '@/modules/backend/Entities/Rate';
import { plainToClass } from 'class-transformer';
import { EditRateData } from '@/modules/backend/Dto/EditRateData';
import { CreateRateData } from '@/modules/backend/Dto/CreateRateData';

/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Rates
 */
export class Rates {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async Get(buildingId: number): Promise<Rate[]> {
    const items = await this.rest.get<unknown[]>(`/api/v1/building/${buildingId}/rates`);

    return plainToClass(Rate, items);
  }

  public async getForAccount(accountId: number): Promise<Rate[]> {
    const items = await this.rest.get<unknown[]>(`/api/v1/account/${accountId}/rates`);

    return plainToClass(Rate, items);
  }

  public async Create(payload: CreateRateData): Promise<Rate> {
    const item = await this.rest.post('/api/v1/rate', payload);

    return plainToClass(Rate, item);
  }

  public async Edit(payload: EditRateData): Promise<Rate> {
    const item = await this.rest.put('/api/v1/rate', payload);

    return plainToClass(Rate, item);
  }

  public async remove(rateId: number): Promise<void> {
    await this.rest.delete(`/api/v1/rate/${rateId}`);
  }

  public async reset(buildingId: number): Promise<Rate[]> {
    const items: unknown[] = await this.rest.post(`/api/v1/building/${buildingId}/rates/reset`);

    return plainToClass(Rate, items);
  }
}
